import { createFileRoute } from '@tanstack/react-router';

import { PageSkeleton } from 'components/templates/PageSkeleton';
import { Step } from 'pages/Signup/Step';
import { LeadProvider } from 'providers/LeadProvider';
import { StepsProvider } from 'providers/StepsProvider';
import {
  getLeadQueryOptions,
  resolveLeadQueryVariables,
} from 'services/partnersSelfSignup/signup';

import { SignupChatbot } from './-components/SignupChatbot';

export const Route = createFileRoute('/_signup')({
  component: () => (
    <LeadProvider>
      <StepsProvider>
        <Step />
        <SignupChatbot />
      </StepsProvider>
    </LeadProvider>
  ),
  pendingComponent: PageSkeleton,
  beforeLoad: async ({ context }) => {
    const { queryClient } = context;

    await queryClient.query(
      getLeadQueryOptions(resolveLeadQueryVariables(queryClient)),
    );
  },
});
